// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._c71lviql{max-height:2rem}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/smart-card/dist/esm/view/FlexibleCard/components/blocks/footer-block/resolved/index.compiled.css"],"names":[],"mappings":"AAAA,WAAW,eAAe","sourcesContent":["._c71lviql{max-height:2rem}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
